import { Route } from "@angular/router";
import { PainelOfertasCadastroPage } from "./painel-ofertas-cadastro.page";

export const PainelOfertasCadastroRouter: Route[] = [
  { path: 'painel-ofertas-cadastro', component: PainelOfertasCadastroPage }
];
